module.exports = __webpack_public_path__ + "img/header-about.2692e2c4.jpg";